<template>
  <div class="hidden props-group">
    <el-form-item label="隐藏">
      <el-switch v-model="component.properties.hidden"></el-switch>
    </el-form-item>
     <el-form-item label="占位置" v-if="component.componentType!=='rc-group'&&component.properties.hidden">
       <el-tooltip content="如勾选,则该控件在隐藏的情况下,也占用原布局的位置,如不勾选,则不占原空间位置(仅限上下位置)" placement="top" class="tooltip">
          <span class="fa fa-question-circle"></span>
      </el-tooltip>
      <el-checkbox v-model="component.properties.seat"></el-checkbox>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'attr-hidden',
  props: ['component'],
  watch: {
    'component.properties.hidden' (val) {
      if (!val) {
        this.component.properties.seat = false
      }
    }
  }
}
</script>

<style lang="scss">
  .hidden.props-group{
    border-top: 1px solid #ebebeb;
     .el-tooltip {
        color: rgb(192,194,193);
        cursor: pointer;
        &:hover{
          color: #3a8ee6;
        }
     }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/componentAttr/hidden.vue